var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.002 3.213l6.205 2.744a.231.231 0 01.126.215v6.454c0 2.07-.969 4.003-2.584 5.193l-3.958 2.918c-.476.35-1.107.35-1.582 0L7.252 17.82c-1.615-1.19-2.584-3.122-2.584-5.193V6.172a.23.23 0 01.126-.215l-.405-.914.405.914 6.205-2.744a2.47 2.47 0 012.004 0z",
    stroke: "#00163E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 13l1.818 1.909a.5.5 0 00.76-.042L15.332 9.5",
    stroke: "#00163E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgInsurance;